import { initialValueProps } from "@components/features/home/home.type";
import Hotjar from "@hotjar/browser";

const { REACT_APP_SEGMENT_KEY } = process.env;
const { REACT_APP_HOTJAR_SITE_ID } = process.env;
const { REACT_APP_HOTJAR_VERSION } = process.env;
export const load = () => {
  window.analytics.load(REACT_APP_SEGMENT_KEY!);
  Hotjar.init(
    parseInt(REACT_APP_HOTJAR_SITE_ID!, 10),
    parseInt(REACT_APP_HOTJAR_VERSION!, 10)
  );
};
export const page = () => {
  window.analytics.page();
};

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const identify = (user: initialValueProps) => {
  window.analytics.identify(user.uuid, {
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    avatar: user.profileImg,
    timezone: userTimeZone,
  });
};
